/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description track optimizely phone call events
 */

import * as Optimizely from '../../../../shared/packages/optimizely-middleware'
import {
  CALL_FROM_STICKY_BAR,
  DIRECT_DEAL_LEADS_SENT,
  DIRECT_DEAL_PHONE_CALL,
  LEAD_SENT,
  MONETIZED_PHONE_CALL,
  PHONE_CALL,
  THIRD_PARTY_PHONE_CALL,
} from '../constants'

/**
 *
 * @param {{ entity: MaybeEmptyProperty, fromStickyBar?: boolean }} param0
 * @returns
 */
const trackOptimizelyPhoneEvents =
  ({ entity, fromStickyBar }) =>
  (dispatch) => {
    dispatch(Optimizely.track({ eventKey: LEAD_SENT }))
    dispatch(Optimizely.track({ eventKey: PHONE_CALL }))
    if (entity) {
      const { isDirectDeal, isThirdPartyPaid } = entity
      if (isDirectDeal) {
        dispatch(Optimizely.track({ eventKey: DIRECT_DEAL_PHONE_CALL }))
        // monetized phone calls are exactly only direct deal phone calls right now,
        // but this can change in the future. see https://github.com/zumper/zumper_code/issues/21734
        dispatch(Optimizely.track({ eventKey: MONETIZED_PHONE_CALL }))
        dispatch(Optimizely.track({ eventKey: DIRECT_DEAL_LEADS_SENT }))
      }
      if (isThirdPartyPaid) {
        dispatch(Optimizely.track({ eventKey: THIRD_PARTY_PHONE_CALL }))
      }
    }
    if (fromStickyBar) {
      dispatch(Optimizely.track({ eventKey: CALL_FROM_STICKY_BAR }))
    }
  }

export default trackOptimizelyPhoneEvents
